import React, { Component } from "react";
import { connect } from 'react-redux';
import JsonForm from "react-jsonschema-form";
import { updateApplication, rewindApplication } from 'actions/applications';

class FormBase extends Component {
  static defaultProps = {
    showGoBack: true
  }

  onSubmit = ({ formData }) => {
    const { application, dispatch } = this.props;
    return dispatch(updateApplication(application, formData));
  }

  handleGoBack = () => {
    const { dispatch, application } = this.props;
    dispatch(rewindApplication(application));
  }

  render = () => {
    const { schema, uiSchema } = this.props;
    const display = this.props.confirmation ? 'none' : '';
    const finalUISchema = this.props.confirmation ? { ...uiSchema, 'ui:readonly': true } : uiSchema;

    return (
      <JsonForm
        schema={schema}
        uiSchema={finalUISchema}
        formData={this.props.application.form}
        onSubmit={this.onSubmit}
        validate={this.props.validate}
      >
        <div style={{ textAlign: 'right', display}}>
          { this.props.showGoBack &&
            <button className='btn btn-default' type='button' onClick={this.handleGoBack}>Go back</button> }
          <button className='btn btn-primary' type='submit' style={{ marginLeft: 15 }}>Continue</button>
        </div>
      </JsonForm>
    );
  }
}

const connected = connect(() => {})(FormBase);
export default connected;



// WEBPACK FOOTER //
// ./src/containers/Application/formBase.js